export default {
  namespaced: true,
  state: 
  {
    usuario: JSON.parse(localStorage.getItem('usuario') || null),
    cliente: JSON.parse(localStorage.getItem('cliente') || null)
  },

  mutations: 
  {
    saveUsuario (state, user) 
    {
      state.usuario = user
      localStorage.setItem("usuario",JSON.stringify(user));
    },

    saveCliente (state, cliente) 
    {
      state.cliente = cliente
      localStorage.setItem("cliente",JSON.stringify(cliente));
    },

    deleteUser (state) 
    {
      state.usuario = null
      localStorage.removeItem("usuario");
    },

    deleteCliente (state) 
    {
      state.cliente = null
      localStorage.removeItem("cliente");
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js